import React, { useState, useRef } from 'react';
import './Home.css';

const Home = () => {
    // Navigation state
    const [isOpen, setIsOpen] = useState(false);

    // Takeover states for the two split sections
    const [isHardwareExpanded, setIsHardwareExpanded] = useState(false);
    const [isSoftwareExpanded, setIsSoftwareExpanded] = useState(false);

    // Refs for independent carousel scrolling
    const miniCarouselRef = useRef(null);
    const hardwareCarouselRef = useRef(null);
    const softwareCarouselRef = useRef(null);

    // 1. Mini Projects (Top Carousel)
    const miniProjects = [
        {
            id: 1,
            title: 'PCB Design',
            category: 'Hardware',
            description: '',
            image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80'
        },
        {
            id: 2,
            title: '',
            category: 'High-speed',
            description: '',
            image: ''
        },
        {
            id: 3,
            title: '',
            category: 'Artificial intelligence',
            description: '',
            image: ''
        },
        {
            id: 4,
            title: '',
            category: 'Software',
            description: '',
            image: ''
        }
    ];

    // 2. Hardware Projects (First Split Section)
    const hardwareProjects = [
        {
            id: 1,
            title: '',
            category: '',
            description: '',
            image: ''
        },
        {
            id: 2,
            title: '',
            category: '',
            description: '',
            image: ''
        },
        {
            id: 3,
            title: '',
            category: '',
            description: '',
            image: ''
        },
        {
            id: 4,
            title: '',
            category: '',
            description: '',
            image: ''
        }
    ];

    // 3. Software Projects (Second Split Section)
    const softwareProjects = [
        {
            id: 1,
            title: '',
            category: '',
            description: '',
            image: ''
        },
        {
            id: 2,
            title: '',
            category: '',
            description: '',
            image: ''
        },
        {
            id: 3,
            title: 'Telemetry Dashboard App',
            category: 'Full-Stack Web',
            description: 'React & Node.js dynamic control panel displaying real-time sensor metrics via WebSockets.',
            image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80'
        },
        {
            id: 4,
            title: '',
            category: '',
            description: '',
            image: ''
        },
        {
            id: 5,
            title: '',
            category: '',
            description: '',
            image: ''
        }
    ];

    // Scroll button helper
    const scroll = (ref, direction) => {
        if (ref.current) {
            const scrollAmount = direction === 'left' ? -380 : 380;
            ref.current.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    // Scroll listeners for the takeover animation
    const handleHardwareScroll = () => {
        if (hardwareCarouselRef.current) {
            const scrollLeft = hardwareCarouselRef.current.scrollLeft;
            setIsHardwareExpanded(scrollLeft > 40);
        }
    };

    const handleSoftwareScroll = () => {
        if (softwareCarouselRef.current) {
            const scrollLeft = softwareCarouselRef.current.scrollLeft;
            setIsSoftwareExpanded(scrollLeft > 40);
        }
    };

    return (
        <>
            {/* NAVBAR */}
            <nav className="navbar">
                <span className="logo">
                    <p>Dongchu <span>Xia</span></p>
                </span>

                <ul className="desktop-menu">
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About me</a></li>
                    <li id="hollow"><a href="#projects">Projects</a></li>
                    <li id="button">
                        <button><a href="#contact">Contact</a></button>
                    </li>
                </ul>

                <button
                    className={`hamburger ${isOpen ? 'active' : ''}`}
                    onClick={() => setIsOpen(!isOpen)}
                    aria-label="Toggle navigation"
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>

                <ul className={`mobile-menu ${isOpen ? 'active' : ''}`}>
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About me</a></li>
                    <li><a href="#projects">Projects</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>
            </nav>

            {/* HERO SECTION */}
            <section className="hero-container">
                <div className="hero-left">
                    <h1 className="welcome">
                        Welcome to my portfolio! My name is <span id="name">Dongchu Xia</span>
                    </h1>
                    <p className="intro-text">
                        Hello! I'm <span className="highlight">Dongchu Xia</span>, an Electrical Engineering student
                        at <span className="highlight">TU Delft</span>. I'm passionate about hardware design and web development
                    </p>
                    <div className="stats-container">
                        <div className="stat-card">
                            <h3>1+</h3>
                            <p>Years at TU Delft</p>
                        </div>
                        <div className="stat-card">
                            <h3>10+</h3>
                            <p>Hardware Projects</p>
                        </div>
                        <div className="stat-card">
                            <h3>core focus</h3>
                            <p>analog circuits design</p>
                        </div>
                    </div>
                </div>

                <div className="hero-right">
                    <div className="right-stats-container">
                        <div className="right-stat-card card-purple">
                            <h2 className="stat-number">15+</h2>
                            <p className="stat-label">Courses Taken</p>
                        </div>
                        <div className="right-stat-card card-orange">
                            <h2 className="stat-number">2+</h2>
                            <p className="stat-label">Certificates</p>
                        </div>
                        <div className="right-stat-card card-cyan">
                            <h2 className="stat-number">400+</h2>
                            <p className="stat-label">Hours Self-Study</p>
                        </div>
                    </div>

                    <div className="skills-container">
                        <h2 className="skills-title">Technical Skills</h2>

                        <div className="skill-item">
                            <div className="skill-info">
                                <span className="skill-name">PCB Design</span>
                                <span className="skill-percent">70%</span>
                            </div>
                            <div className="skill-bar">
                                <div className="skill-progress pcb"></div>
                            </div>
                        </div>

                        <div className="skill-item">
                            <div className="skill-info">
                                <span className="skill-name">Analog Circuit Design</span>
                                <span className="skill-percent">85%</span>
                            </div>
                            <div className="skill-bar">
                                <div className="skill-progress analog"></div>
                            </div>
                        </div>

                        <div className="skill-item">
                            <div className="skill-info">
                                <span className="skill-name">Web Development</span>
                                <span className="skill-percent">65%</span>
                            </div>
                            <div className="skill-bar">
                                <div className="skill-progress web"></div>
                            </div>
                        </div>

                        <div className="skill-item">
                            <div className="skill-info">
                                <span className="skill-name">C programming</span>
                                <span className="skill-percent">65%</span>
                            </div>
                            <div className="skill-bar">
                                <div className="skill-progress clang"></div>
                            </div>
                        </div>

                        <div className="skill-item">
                            <div className="skill-info">
                                <span className="skill-name">AI with Python</span>
                                <span className="skill-percent">75%</span>
                            </div>
                            <div className="skill-bar">
                                <div className="skill-progress ai"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =================================== */}
            {/* ABOUT ME SECTION                    */}
            {/* =================================== */}
            <section className="about-section" id="about">
                <div className="about-wrapper">
                        <h2 className="about-title">About Me</h2>
                    </div>

                    <div className="about-content">
                        <p className="about-text">
                            Hey! I'm <span className="highlight">Dongchu Xia</span>, a 20-year-old introverted engineering student. While I'm still working on getting more comfortable with coding, I really enjoy web development.
                            Right now, I'm learning Java, the MERN stack, and Python for AI.I'm good with circuits.
                        </p>
                    </div>
            </section>

            {/* 1. TOP MINI CAROUSEL (miniProjects) */}
            <div className="home-mini-carousel-container">
                <div className="mini-carousel-header">
                    <h3 className="mini-carousel-title">Featured Work</h3>

                    <div className="mini-carousel-buttons">
                        <button onClick={() => scroll(miniCarouselRef, 'left')} aria-label="Previous">‹</button>
                        <button onClick={() => scroll(miniCarouselRef, 'right')} aria-label="Next">›</button>
                    </div>
                </div>

                <div className="mini-carousel-track" ref={miniCarouselRef}>
                    {miniProjects.map((item) => (
                        <div className="mini-card" key={item.id}>
                            <div className="mini-card-image">
                                <img src={item.image} alt={item.title}/>
                                <span className="mini-card-category">{item.category}</span>
                            </div>

                            <div className="mini-card-content">
                                <h4 className="mini-card-title">{item.title}</h4>
                                <p className="mini-card-desc">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="accent-bar-track">
                    <div className="accent-bar-fill"></div>
                </div>
            </div>

            {/* 2. HARDWARE SPLIT SECTION (hardwareProjects) */}
            <section className={`nvidia-split-section ${isHardwareExpanded ? 'takeover-active' : ''}`}>
                <div className="split-header-row">
                    <div className="split-header-left">
                        <h2 className="split-title">Hardware Projects</h2>
                    </div>

                    <div className="split-carousel-buttons">
                        <button onClick={() => scroll(hardwareCarouselRef, 'left')} aria-label="Previous">‹</button>
                        <button onClick={() => scroll(hardwareCarouselRef, 'right')} aria-label="Next">›</button>
                    </div>
                </div>

                <div className="accent-bar-track">
                    <div className="accent-bar-fill"></div>
                </div>

                <div className="split-content-container">
                    <div className="split-left-info">
                        <p className="split-description">
                            Designed and built hardware projects through self-learning, including circuit design, schematic capture, 2-layer and 4-layer PCB design, and hardware debugging
                        </p>
                    </div>

                    <div
                        className="split-right-carousel"
                        ref={hardwareCarouselRef}
                        onScroll={handleHardwareScroll}
                    >
                        {hardwareProjects.map((item) => (
                            <div className="split-card" key={item.id}>
                                <div className="split-card-image">
                                    <img src={item.image} alt={item.title}/>
                                    <span className="split-card-badge">{item.category}</span>
                                </div>

                                <div className="split-card-body">
                                    <div className="split-card-header-row">
                                        <h4 className="split-card-title">{item.title}</h4>
                                        <p className="split-card-desc">{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 3. SOFTWARE SPLIT SECTION (softwareProjects) */}
            <section className={`nvidia-split-section ${isSoftwareExpanded ? 'takeover-active' : ''}`}>
                <div className="split-header-row">
                    <div className="split-header-left">
                        <h2 className="split-title">Software Projects</h2>
                    </div>

                    <div className="split-carousel-buttons">
                        <button onClick={() => scroll(softwareCarouselRef, 'left')} aria-label="Previous">‹</button>
                        <button onClick={() => scroll(softwareCarouselRef, 'right')} aria-label="Next">›</button>
                    </div>
                </div>

                <div className="accent-bar-track">
                    <div className="accent-bar-fill"></div>
                </div>

                <div className="split-content-container">
                    <div className="split-left-info">
                        <p className="split-description">
                            Built software projects to learn full-stack development (MERN), AI, Python, and automation, gaining practical experience through hands-on projects.
                        </p>
                    </div>

                    <div
                        className="split-right-carousel"
                        ref={softwareCarouselRef}
                        onScroll={handleSoftwareScroll}
                    >
                        {softwareProjects.map((item) => (
                            <div className="split-card" key={item.id}>
                                <div className="split-card-image">
                                    <img src={item.image} alt={item.title}/>
                                    <span className="split-card-badge">{item.category}</span>
                                </div>

                                <div className="split-card-body">
                                    <div className="split-card-header-row">
                                        <h4 className="split-card-title">{item.title}</h4>
                                        <p className="split-card-desc">{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* =================================== */}
            {/* CONTACT SECTION (SPLIT LAYOUT)      */}
            {/* =================================== */}
            <section className="contact-section" id="contact">
                <div className="contact-split-container">

                    {/* Left Side: Contact Form */}
                    <div className="contact-left-col">
                        <div className="section-header-compact">
                            <h2 className="contact-title">Let's Connect</h2>
                            <p className="contact-subtitle">
                           Send me a message.
                            </p>
                        </div>

                        <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" placeholder="Your Name" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" placeholder="your.email@example.com" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="subject">Subject</label>
                                <input type="text" id="subject" placeholder="Project Inquiry" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea id="message" rows="4" placeholder="Write your message here..." required></textarea>
                            </div>

                            <button type="submit" className="contact-submit-btn-blue">
                                <span>Send Message</span>
                                <span className="btn-arrow">→</span>
                            </button>
                        </form>
                    </div>

                    {/* Right Side: Age, Personal Character & Hobby (Blue Badges) */}
                    <div className="contact-right-col">
                        <div className="section-header-compact">
                            <h2 className="contact-title">Profile Info</h2>
                            <p className="contact-subtitle">
                                A quick glance at my age, character, and interests.
                            </p>
                        </div>

                        <div className="profile-info-cards">
                            <div className="info-card-item">
                                <span className="info-label">Age</span>
                                <span className="info-value">21</span>
                            </div>

                            <div className="info-card-item">
                                <span className="info-label">Personal Character</span>
                                <span className="info-value">Introvert, curious, and kind</span>
                            </div>

                            <div className="info-card-item">
                                <span className="info-label">Hobby</span>
                                <div className="badge-container">
                                    <span className="profile-badge-blue">Music listening</span>
                                    <span className="profile-badge-blue">Wacthing movies</span>
                                    <span className="profile-badge-blue">Circuits</span>
                                    <span className="profile-badge-blue">Web development</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default Home;